import  React from 'react';
import { Button, Flyout } from '@a-ui/react';

const UserMenu = (props) => {

  const letters = () => {
    const { firstName, lastName } = props.user;
    const firstInitial = firstName.charAt(0).toUpperCase();
    const secondInitial = lastName.charAt(0).toUpperCase();
    return (firstInitial + secondInitial);
  }

  const login = () => {
    if (typeof window !== 'undefined') {
      window.location.href = props.loginUrl;
    }
  }

  const logout = () => {
    if (typeof window !== 'undefined') {
      window.location.href = props.logoutUrl;
    }
  }

  const renderLoggedIn = () => {
    const { firstName, lastName, avatarUrl } = props.user;

    return <Flyout
      orientation="bottom-right"
      hasPadding={false}
      size="small"
      trigger={<Button
        className="a-button--neutral o-header__button"
        aria-label="open menu"
        emphasis="low"
        addOn={{
          type: "avatar",
          avatarProps: {
            letter: letters(),
            image: avatarUrl ? avatarUrl : null,
          },
        }}
      >
        <span>{firstName} {lastName}</span>
      </Button>}
    >
      <Button
        fullWidth={true}
        theme="danger"
        aria-label="logout"
        addOn={{
          type: "icon",
          align: "left",
          iconProps: {
            name: "ai-power-button",
          },
        }}
        onClick={() => logout()}
      >
        Afmelden
      </Button>
    </Flyout>;
  }

  const renderLoggedOut = () => {
    return <Button
      className="a-button--neutral o-header__button"
      aria-label="login"
      emphasis="low"
      addOn={{
        type: "icon",
        align: "left",
        iconProps: {
          name: "ai-single-neutral",
        },
      }}
      onClick={() => login()}
    >
      Aanmelden
    </Button>
  }

  return (props.user && Object.keys(props.user).length) ? renderLoggedIn() : renderLoggedOut();

}

export default UserMenu;
